import React from 'react';
import { animateProgress } from '../../../../services/animate';

export default class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current_progress: 0,
      title: 'Jeszcze moment!',
      subtitle: 'Szukamy hoteli!',
      width: 0,
      loadTime: 20000,
      initialDelayTime: 300,
      delayTime: 100,
      active: true,
      pristine: true
    };
  }

  componentDidMount() {
    this.startAnimation();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.pristine && nextProps.active !== this.state.active) {
      nextProps.active ? this.startAnimation() : this.finishAnimation();
    }
  }

  render = () => (
    <div
      className={`custom-search-loader ${
        this.props.className ? this.props.className : ''
      } ${this.state.active ? 'active' : ''}`}
    >
      <h3 className="title">
        {this.props.title ? this.props.title : this.state.title}
      </h3>
      <p className="subtitle">
        {this.props.subtitle ? this.props.subtitle : this.state.subtitle}
      </p>
      <span className="hyphen" />
      <div className="search-loader-wrapper">
        <div
          className="loader-indicator"
          style={{ width: `${this.state.width}%` }}
        >
          <span className="loader-icon" />
        </div>
      </div>
    </div>
  );

  updateLoader = currentProgress => this.setState({ width: currentProgress });

  closeLoader = () => {
    this.setState({ active: false }, () => {
      setTimeout(() => {
        this.setState({ width: 0 });
      }, 100);
    });
  };

  startAnimation = () => {
    const state = this.state.pristine;
    this.setState({ pristine: false, active: true }, () => {
      const delay = state ? this.state.initialDelayTime : this.state.delayTime;
      animateProgress(
        this.updateLoader,
        false,
        0,
        95,
        this.state.loadTime,
        'easeOutCubic',
        delay
      );
    });
  };

  finishAnimation = () => {
    localStorage.setItem('offersLock', new Date().getTime());
    animateProgress(
      this.updateLoader,
      this.closeLoader,
      this.state.width,
      100,
      100,
      'linear'
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/hotels_list/loader.js